export enum CAP_INFO_TYPE {
	LIFETIME = 'Lifetime',
	MONTHLY = 'Monthly',
	TITLE = 'Annual'
}
